import { FORM_NAME, SavedValues } from "@/forms/conductor";
import { restoreForm } from "@/helpers/form-history";
import { formatarCEP } from "@/utils/stringUtils";
import { useRouter } from "next/router";

export default function useFormHistory() {
  const router = useRouter();

  const condutor = restoreForm<SavedValues>(FORM_NAME, (values) => values.rate_id === router.query.rate_id, (values) => ({
    ...values,
    cep: formatarCEP(values.cep),
  }));

  return {
    condutor
  }
}
